import { createApp } from 'vue'
import App from './App.vue'
import router from './router/router'
import store from './store'
import 'driver.js/dist/driver.css'

import vuetify from '@/plugins/vuetify'


import Highcharts from 'highcharts'
import VueHighcharts from 'vue-highcharts'
import highchartsMore from 'highcharts/highcharts-more'

highchartsMore(Highcharts)


import '@mdi/font/css/materialdesignicons.css'
import './scss/app.scss'

createApp(App)
.use(store)
.use(router)
.use(vuetify)
.use(VueHighcharts, {Highcharts})
.mount('#app')
